import './styles.scss'
import 'react-toastify/dist/ReactToastify.css'
import 'moment-timezone'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Col, Alert } from 'reactstrap'
import { toast } from 'react-toastify'
import moment from 'moment'

import { company, apiConversation, bitrix, meetAPI, apiPools } from 'api'
import { activeUserAct, composerAct } from '../../../../redux/actions'
import messageFiltersAct from '../../../../redux/actions/conversations/messageFiltersAct'
import { toggleDeferredShown } from '../../../../redux/actions/conversations/messagesAct'
import { removeUserTabs } from '../../../../redux/actions/tabs'
import { removeConversation } from '../../../../redux/actions/conversations/conversations'
import { conversationAct } from '../../../../redux_new/actions'
import poolListsAct from '../../../../redux/poolLists/actions'

import ModalWrapper from 'components/ModalWrapper'
import Nixi1Spinner from 'components/Nixi1Spinner'
import CheckboxSelector from 'components/CheckboxSelector'
import Counter from '../../../common/Counter'
import { SelectWithLabel } from '../../../Form'
import EditUser from '../../../EditUser'
import AssignOperator from '../../../AssignOperator'
import { USER_STATES } from '../../../../constants'
import { Button } from '../../../Form'
import { getStaticImage } from 'utils/statics'
import { toastMessage } from 'utils/messages'
import { lang } from 'utils/helpers'

const ChatChannelUserInfo = (props) => {
  const { companies, user, dispatch, loggedUser, chat, getSetting, setting, modules, isListsAvailable } = props

  const history = useHistory()
  const subjectId = useSelector(state => state.conversations[user.id].composer.currentSubject?._id)
  const composer = useSelector(state => state.conversations[user.id].composer)
  const onActiveUser = bindActionCreators(activeUserAct, dispatch)
  const messageFiltersAction = bindActionCreators(messageFiltersAct, dispatch)

  const [typeModal, setTypeModal] = useState('')
  const [errors, setErrors] = useState('')
  const [isOpenAutomatizationModal, setIsOpenAutomatizationModal] = useState(false)
  const [automatizationIcon, setAutomatizationIcon] = useState('')
  const [automatizationModalContent, setAutomatizationModalContent] = useState('')
  const [userLists, setUserLists] = useState([])
  const [ subjectState, setSubjectState ] = useState(composer?.subjectState)
  const [loadingMeetLink, setLoadingMeetLink] = useState(false)
  const CHANNELS_WITH_COUNTER = ['facebook', 'whatsapp', 'instagram']
  const withCounterTime = CHANNELS_WITH_COUNTER.includes(user?.channels?.[0]?.channel)

  useEffect(() => {
    setAutomatizationIcon('')
    getAutomationIcon()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setting, modules, user])

  useEffect(
    () => {
      getListsByUser(user.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.id]
  )

  useEffect(() => {
    if (user.provider_name === 'chatmail') {
      setSubjectState(composer?.subjectState)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [composer.currentSubject, composer.subjectState])

  const onChangeUserState = ({ target }) => apiConversation.conversations.changeState({ userId: user._id, state: target.value, subjectId: subjectId })

  const onOpenModal = (typeModal = '') => setTypeModal(typeModal)

  const toggleAutomatizationModal = () => setIsOpenAutomatizationModal(!isOpenAutomatizationModal)

  const updateUser = (newData, openModal) =>
    onActiveUser
      .updateUser(newData)
      .then(() => {
        if (!openModal) onOpenModal()
      })
      .catch(setErrors)

  const combinedChannels = () => {
    if(!user.isRemoveByUser) messageFiltersAction.toggleMessageFilter(user.id, 'combineChannels')
  }

  const isIncludes = user.assignedTo?.includes(loggedUser._id)
  const operatorCanAssignACardToItself = !isIncludes
  const operatorCanUnassignACardFromHimself = isIncludes

  const apiAssignationsUsers = company.assignationsUsers

  const assignToMyself = () => {
    if(!user.isRemoveByUser) {
      const assignedId = loggedUser._id

      apiAssignationsUsers
        .add({
          userId: user.id,
          operator: { id: assignedId, company: user.company },
          operatorIds: [assignedId],
        })
        .then(({ data }) => {
          if (data.statusOk) {
            // updateUser({ ...data.results })
            // SEND THE TOAST
            toast(lang('dashboard_assigned-conversation'), { position: 'top-center' })
          }
        })
        .catch(console.error)
    }
  }

  const unassignMe = () => {
    if(!user.isRemoveByUser) {
      apiAssignationsUsers
        .remove({
          userId: user.id,
          operator: { id: loggedUser._id, company: user.company },
          operatorIds: [loggedUser._id],
        })
        .then(({ data }) => {
          if (data.statusOk) {
            // updateUser({ ...data.results })
            toast(lang('dashboard_unassigned-conversation'), { position: 'top-center' })
          }
        })
        .catch(console.error)
    }
  }

  const toggleDeferred = () => {
    dispatch(toggleDeferredShown(user.id))
  }

  const isReadRequest = async (isRead) => {
    try {
      if (isRead && user.isRead)
        return true

      await apiConversation.conversations.msgRead({
        ticketId: user._id,
        isRead
      })

      if (user.isInList) {
        dispatch(poolListsAct.event({ onlyListIsAvailable: true }))
      }

      return true
    } catch(error) {
      return false
    }
  }

  const changeIsRead = async (value) => {
    if(!user.isRemoveByUser){
      isReadRequest(!value)

      if (value) {
        history.push(`${history.location.pathname}`)
        dispatch(removeUserTabs(user.id))
        dispatch(removeConversation(user.id))
        dispatch(conversationAct.removeOne(user.id))
      }
    }
  }

  const states = USER_STATES['all'].map((state) => ({
    value: state,
    label: lang(`states_${state}`),
  }))

  const statesWithRemoveByUser = USER_STATES['removeByUser'].map((state) => ({
    value: state,
    label: lang(`states_${state}`),
  })).concat(states)

  const statesWithNauta = USER_STATES['nauta'].map((state) => ({
    value: state,
    label: lang(`states_${state}`),
  })).concat(statesWithRemoveByUser)

  const handleCreateCrm = (data) => {
    if (!data.isRemoveByUser){
      bitrix.createCrm(data)
        .then(() => {
          toastMessage(lang('bitrix_successful_createCrm'))
        })
        .catch(() => {
          toastMessage(lang('bitrix_error_createCrm'), 'error')
        })
    }
  }

  const getAutomationIcon = () => {
    if (!setting?.schedule) return null
    const timeZone = setting?.schedule?.timeZone
    const currentDay = moment().tz(timeZone).locale('en').format('dddd').toLowerCase()

    const schedule = setting?.schedule[currentDay]?.ranges?.find(range => {
      const startTime = moment.tz(range.start, 'hh:mm', timeZone)
      const endTime = moment.tz(range.end, 'hh:mm', timeZone)
      return moment().tz(timeZone).isBetween(startTime, endTime)
    })

    const automationIsEnabled = () => {
      if (schedule?.tag === 'smartChat' && !setting.isSmartChatActive) return false
      if (schedule?.tag === 'automaticResponsesVA' && !setting.isFaqConsoleActive) return false
      if (schedule?.tag === 'operatorAssistantVA' && !setting.isVirtualAssistantActive) return false

      return true
    }

    if (!modules?.faqConsole?.isActive) {
      setAutomatizationIcon('bot-config-off')
      setAutomatizationModalContent('composer_automatization_botOff')
      return null
    }
    if (!schedule || !setting?.schedule?.isActive || !setting?.schedule[currentDay]?.isActive) {
      setAutomatizationIcon('bot-config-off')
      setAutomatizationModalContent('composer_automatization_botOff_calendar')
      return null
    }
    if (!automationIsEnabled()) {
      setAutomatizationIcon('bot-config-off')
      setAutomatizationModalContent('composer_automatization_botOff_automation')
      return null
    }
    if (!setting?.isChannelAutomationEnabled) {
      setAutomatizationIcon('bot-config-off')
      setAutomatizationModalContent('composer_automatization_botOff_channel')
      return null
    }

    if (schedule?.tag === 'smartChat') {
      if (!user.isAutomationEnabled || !user.isSmartChatActive) {
        return setAutomatizationIcon('bot-smartchat-off')
      } else {
        return setAutomatizationIcon('bot-smartchat')
      }
    }
    if (schedule?.tag === 'automaticResponsesVA') {
      if (!user.isAutomationEnabled || !user.isFaqConsoleActive) {
        return setAutomatizationIcon('bot-response-off')
      } else {
        return setAutomatizationIcon('bot-response')
      }
    }
    if (schedule?.tag === 'operatorAssistantVA') {
      if (!user.isAutomationEnabled) {
        return setAutomatizationIcon('bot-assistant-off')
      } else {
        return setAutomatizationIcon('bot-assistant')
      }
    }
  }

  const updateStatus = async (value) => {
    const data = { ...user, isAutomationEnabled: value }
    apiConversation.users.updateUser(data)
  }

  const handleAutomatizationIcon = () => {
    if (automatizationModalContent) return toggleAutomatizationModal()
    updateStatus(!user.isAutomationEnabled)
  }

  const isDisabledSelectState = () => {
    if (user.state === 'removeByUser') return true
    return user.provider_name !== 'chatmail' ? false : subjectId ? false : true
  }

  const handleClickToCall = () => {
    setLoadingMeetLink(true)

    meetAPI.createLink({ conversationId: user._id })
      .then(({ data }) => {
        dispatch(composerAct.addExternalText(data.message || `${lang('dashboard_meet-link-created')}:`))
        dispatch(composerAct.updateButtons([
          { label: lang('dashboard_videocall'), content: data.url, type: "url" }
        ]))
        navigator.clipboard.writeText(data.url)
        toastMessage(lang('dashboard_videocall-url-copied-clipboard'))
      })
      .catch(console.error)
      .finally(() => setLoadingMeetLink(false))
  }

  const getListsByUser = (userId) => {
    dispatch(poolListsAct.getListsByUser(userId))
      .then(data => {
        setUserLists(data.lists.map(list => ({ ...list, isSelected: data.userLists.includes(list._id) })))
      })
      .catch(console.error)
  }

  const handleFolder = ({ id, value }) => {
    const prevUserLists = [...userLists]

    const listIndex = userLists.findIndex(userList => userList._id === id)
    setUserLists(prevState => Object.assign([...prevState], {
      [listIndex]: {
        ...prevState[listIndex],
        isSelected: value
      }
    }))

    apiPools.listEdit({
      action: value ? 'add' : 'remove',
      userId: user.id,
      listId: id
    })
      .catch(error => {
        setUserLists(prevUserLists)
        console.error(error)
      })
  }

  return (
    <div className='chat-top-info'>
      <div className='chat-top-info__actions-container'>
        {/* EDIT USER */}
        <button
          className='chat-top-info__icon-btn'
          title={lang('dashboard_edit-user')}
          onClick={() => onOpenModal('userModal')}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-edit-primary.svg')} alt='Edit user' />
          </figure>
        </button>

        {/* ASSIGN */}
        {
          !loggedUser.onlyAssignedConversations && operatorCanAssignACardToItself
            ? (
              <button
                className='chat-top-info__icon-btn'
                title={lang('dashboard_associate-conversation-for-me')}
                onClick={assignToMyself}
              >
                <figure>
                  <img
                    src={!user.isRemoveByUser
                      ? getStaticImage('/icons/orange-brand/icon-asign-primary.svg')
                      : getStaticImage('/icons/orange-brand/icon-asign-grey.svg')
                    }
                    alt='Asign me' />
                </figure>
              </button>
            )
            : null
        }

        {/* UNASSIGN */}
        {operatorCanUnassignACardFromHimself ? (
          <button
            className='chat-top-info__icon-btn'
            title={lang('dashboard_remove-assignment')}
            onClick={unassignMe}
          >
            <figure>
              <img
                src={!user.isRemoveByUser
                  ? getStaticImage('/icons/orange-brand/icon-unasign-primary.svg')
                  : getStaticImage('/icons/orange-brand/icon-unasign-grey.svg')
                }
                alt='Unasign me' />
            </figure>
          </button>
        ) : null}

        {/* ASSIGN TO OTHER */}
        <button
          className='chat-top-info__icon-btn'
          title={lang('dashboard_associate-conversation-another-person')}
          onClick={() => onOpenModal('assignedModal')}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-asign-other-primary.svg')} alt='Asign to other' />
          </figure>
        </button>

        {/* MERGE MESSAGES */}
        <button
          className='chat-top-info__icon-btn'
          title={lang('dashboard_message-merging')}
          onClick={combinedChannels}
        >
          <figure>
            <img
              src={!user.isRemoveByUser
                ? getStaticImage('/icons/orange-brand/icon-compress-primary.svg')
                : getStaticImage('/icons/orange-brand/icon-compress-grey.svg')
              }
              alt='Merge messages'
            />
          </figure>
        </button>

        {/* READ MESSAGES */}
        <button
          className='chat-top-info__icon-btn'
          title={lang('dashboard_mark-conversation-unread')}
          onClick={() => changeIsRead(user.isRead)}
        >
          <figure>
            <img
              src={!user.isRemoveByUser
                ? getStaticImage('/icons/orange-brand/icon-unread-primary.svg')
                : getStaticImage('/icons/orange-brand/icon-unread-grey.svg')
              }
              alt='Mark as unread'
            />
          </figure>
        </button>

        {/* CRM */}
        {(companies.nixi1Bitrix24 && !user.bitrix24Lead) ? (
          <button
            className='chat-top-info__icon-btn'
            title={lang('bitrix_btn_createCrm')}
            onClick={() => handleCreateCrm({ userId: user._id })}
          >
            <figure>
              <img
                src={getStaticImage('/icons/orange-brand/icon-lead-primary.svg')}
                alt={lang('bitrix_btn_createCrm')}
              />
            </figure>
          </button>
        ) : null}

        {/* AUTOMATION */}
        {automatizationIcon ? (
          <button
            className='chat-top-info__icon-btn'
            title={lang(`dashboard_${automatizationIcon}`)}
            onClick={handleAutomatizationIcon}
          >
            <figure>
              <img
                src={getStaticImage(`/icons/orange-brand/icon-${automatizationIcon}-primary.svg`)}
                alt={lang(`dashboard_${automatizationIcon}`)}
              />
            </figure>
          </button>
        ) : null}

        {/* DEFERRED */}
        {chat.deferredMessages.messages.length > 0 ? (
          <button
            className='chat-top-info__icon-btn'
            title={lang('dashboard_deferred-messages')}
            onClick={toggleDeferred}
          >
            <figure>
              <img
                src={!user.isRemoveByUser
                  ? getStaticImage(`/icons/orange-brand/icon-clock-primary.svg`)
                  : getStaticImage(`/icons/orange-brand/icon-clock-grey.svg`)
                }
                alt={lang('dashboard_deferred-messages')}
              />
            </figure>
          </button>
        ) : null}
      </div>
      <div className='chat-top-info__actions-container'>
        {withCounterTime ? (
          <Counter
            lastMessageDate={user.lastMessageDate}
            channel={user?.channels?.[0]?.channel}
          />
        ) : null}
        <button
          className='chat-top-info__icon-btn chat-top-info__icon-btn--videocall'
          title={lang('dashboard_create-videocall-link')}
          onClick={handleClickToCall}
        >
          {!loadingMeetLink ? (
            <figure>
              <img
                src={getStaticImage('/icons/orange-brand/icon-videocall-primary.svg')}
                alt={lang('dashboard_videocall')}
              />
            </figure>
          ) : (
            <Nixi1Spinner width='17px' height='17px' />
          )}
        </button>
        <div className='chat-top-info__selectors-container'>
          {/* FOLDERS */}
          {isListsAvailable ? (
            <CheckboxSelector
              selectorOptions={userLists.map(userList => ({
                iconName: 'folder-dark',
                id: userList._id,
                name: userList.name,
                value: userList.isSelected,
                color: userList.color
              }))}
              onChange={handleFolder}
              tooltip={lang('dashboard_conversation-folders')}
              isDisabled={user.isRemoveByUser ? true : false}
            />
          ) : null}

          {/* STATES */}
          <div title={lang('dashboard_conversation-state')}>
            <SelectWithLabel
              name='state'
              key='state'
              placeholder={user.state}
              classNameWrapper={`chat-top-info__states-selector ${user.state}`}
              options={states}
              value={statesWithNauta.find(element => element.value === (user.provider_name === 'chatmail' ? subjectState || user.state : user.state))}
              onChange={({ value }) => onChangeUserState({ target: { value, name: 'state' } })}
              isDisabled={isDisabledSelectState()}
            />
          </div>
        </div>
      </div>

      {Object.keys(errors).length > 0 &&
        Object.keys(errors).map((e) => (
          <Col key={e} xs={12}>
            <Alert color='danger'>{lang(`dashboard_errors_${errors[e]}`)}</Alert>
          </Col>
        ))
      }

      {typeModal === 'userModal' ? (
        <EditUser
          loggedUser={loggedUser}
          currentUser={user}
          onSubmit={updateUser}
          onHide={onOpenModal}
        />
      ) : null}

      {typeModal === 'assignedModal' ? (
        <AssignOperator
          getSetting={getSetting}
          user={user}
          onAssign={updateUser}
          onDeleteAssignation={updateUser}
          onHide={onOpenModal}
        />
      ) : null}

      <ModalWrapper
        isOpen={isOpenAutomatizationModal}
        toggle={toggleAutomatizationModal}
        header={' '}
        body={
          <div className='modal-content'>
            <p dangerouslySetInnerHTML={{ __html: lang(automatizationModalContent) }}></p>
          </div>
        }
        footer={
          <div className='chat-top-info__automation-buttons-container'>
            <Button
              primary
              value={lang('dashboard_configure')}
              onClick={() => {
                if (automatizationModalContent.includes('calendar') || automatizationModalContent.includes('automation')) {
                  history.push(`${history.location.pathname.split('/conversations')[0]}/automation/console`)
                } else if (automatizationModalContent.includes('channel')) {
                  history.push(`${history.location.pathname.split('/conversations')[0]}/configurations/channels/${setting.channelId}`)
                } else {
                  history.push(`${history.location.pathname.split('/conversations')[0]}/management/plan`)
                }
              }}
            />
            <Button
              value={lang('dashboard_cancel')}
              onClick={toggleAutomatizationModal}
            />
          </div>
        }
      />
    </div>
  )
}

export default connect((state) => ({
  companies: state.companies,
  loggedUser: state.user,
  modules: state.modules,
  isListsAvailable: state.poolLists.isListsAvailable,
  operator: state.user
}))(ChatChannelUserInfo)
